<template>
  <svg :width="width" :height="height" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="19" cy="19" r="19" :fill="color2"/>
  <path d="M28.2555 13.1177L24.8304 9.68026C24.3834 9.25886 23.7977 9.01706 23.1846 9.00087C22.5715 8.98468 21.9739 9.19522 21.5054 9.59244L10.2553 20.8832C9.85122 21.2921 9.59964 21.8281 9.54276 22.4012L9.00525 27.6325C8.98841 27.8163 9.01217 28.0015 9.07483 28.175C9.13749 28.3485 9.23751 28.5059 9.36776 28.6362C9.48456 28.7524 9.62308 28.8444 9.77538 28.9069C9.92768 28.9693 10.0908 29.0009 10.2553 29H10.3678L15.5803 28.5233C16.1513 28.4662 16.6854 28.2137 17.0928 27.8082L28.343 16.5174C28.7796 16.0545 29.0156 15.4367 28.9992 14.7994C28.9828 14.1621 28.7154 13.5574 28.2555 13.1177ZM24.0054 17.3078L20.6554 13.9457L23.0929 11.4366L26.5054 14.8615L24.0054 17.3078Z" :fill="color"/>
</svg>

</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 38
    },
    height: {
      type: Number,
      default: 38
    },
    color: {
      type: String,
      default: 'white'
    },
    color2: {
      type: String,
      default: 'var(--color-pri)'
    }
  }
}
</script>
